import { PizzaIcon } from './PizzaIcon';

/**
 * author: Google
 * id E617E8BD-2C63-4E59-B1F4-EB3F9F3916D3
 * name pizza
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pizza.svg
 * tags
 * - Food / Drink 
 * - Places 
 */
export const LocalPizzaIcon = PizzaIcon;
export default LocalPizzaIcon